/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface ISysqueTooltipFacade {
    getLocalStorageUpdate(): BehaviorSubject<string>;
}

export const SYSQUE_TOOLTIP_FACADE_TOKEN = new InjectionToken<ISysqueTooltipFacade>('SYSQUE_TOOLTIP_FACADE_TOKEN');